import { defineComponent as c, openBlock as e, createBlock as s, unref as n } from "vue";
import t from "./toast-icon.vue.js";
import { ICONS as r } from "../../../components/sequiter-image/icon-library.js";
import { newImageModel as m } from "../../../components/sequiter-image/image-model.js";
const C = /* @__PURE__ */ c({
  name: "toast-success-icon",
  __name: "toast-success-icon",
  setup(a) {
    const o = m(r.CHECKMARK_CIRCLE, "success", "success");
    return (i, p) => (e(), s(t, { icon: n(o) }, null, 8, ["icon"]));
  }
});
export {
  C as default
};
//# sourceMappingURL=toast-success-icon.vue.js.map
